import { combineReducers } from 'redux';
import { Register_form } from './create_account.reducers';
import { Login_form } from './login.reducers';
import { Forgot_password_form } from './forgot_password.reducers';
import { Reset_password_form } from './reset_password.reducers';
import { Verify_account_form } from './verify_account.reducers';
import { Theme } from './theme_reducers';
import { Sidebar } from './sidebar_reducers';
import { Permissions } from './check_permission.reducer';
import { App_content } from './app_content.reducers';
import { modalWindow } from './modalWindow.reducer';

export const App = combineReducers({
    Login_form,
    Register_form,
    Forgot_password_form,
    Reset_password_form,
    Verify_account_form,
    Theme,
    Sidebar,
    Permissions,
    App_content,
    modalWindow,
});



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/index.js